import VueI18n, { LocaleMessageObject, LocaleMessages } from 'vue-i18n';
import { store } from '../../store/store';
import { getConfigByLocale } from '../staticData/staticData.config';
import { availableLocales, fallbacks } from './available-locales';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const lang = urlParams.get('locale');

export const isValidLanguage = (lang: string): boolean => {
  let isValid = false;
  availableLocales.forEach((lng) => {
    if (lng === lang) {
      isValid = true;
    }
  });
  return isValid;
};

const getTranslations = (): LocaleMessages => {
  const translations: { [key: string]: LocaleMessageObject } = {};
  availableLocales.forEach((locale) => {
    translations[locale] = {
      ...require(`./files/${locale}.json`),
      ...getConfigByLocale(locale).messages[locale],
    };
  });
  return translations;
};

export const isQueryLanguageSet = (): boolean => lang !== null;

// set german as default language if no language is defined via url parameter
export const currentLocale = lang && isValidLanguage(lang) ? lang : fallbacks[1] ? fallbacks[1] : fallbacks[0];

store.dispatch('config/setLocale', {
  language: currentLocale.split('_')[0],
  country: currentLocale.split('_')[1],
});

export const i18n = new VueI18n({
  locale: currentLocale,
  fallbackLocale: fallbacks,
  messages: { ...getTranslations() },
});

// hint: i18n must be defined before
export const localizeNumber = (num: number, locale?: typeof availableLocales[number]): string => {
  const currentLocaleWithDash = (locale || i18n.locale).replace('_', '-');
  const localizedNum = num.toLocaleString(currentLocaleWithDash, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  // e.g. do not show 10,00, instead only show 10
  if (localizedNum.endsWith('00')) {
    const delimiterCharacterIndex = Math.max(localizedNum.lastIndexOf(','), localizedNum.lastIndexOf('.'));
    return localizedNum.substring(0, delimiterCharacterIndex);
  }
  return localizedNum;
};
